// @mui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Chip from '@mui/material/Chip'; // models
import { useTranslation } from 'react-i18next';
import { Category, Discount } from '@mui/icons-material';
import Divider from '@mui/material/Divider';
import CardHeader from '@mui/material/CardHeader';
import { CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import { InsightData } from '../../../models/insight-data';

interface Props {
  insights: InsightData[];
}

export const InsightsItemsList = ({ insights }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const style = { color: theme.palette.text.secondary };

  const parseExtract = (extract: string) => (extract ? `"${extract.trim()}"` : '');

  const renderTopics = (topics: string[]) =>
    topics
      .map((to) => (to.length > 1 ? `${to[0]?.toUpperCase()}${to?.slice(1)}` : to || '-'))
      .join(', ');

  return (
    <Stack direction="column" divider={<Divider flexItem />} spacing={2}>
      {insights.map((insight) => (
        <Box
          key={insight.id}
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            // padding: 2,
            backgroundColor: theme.palette.background.paper,
            borderRadius: 1,
            border: `1px solid ${theme.palette.divider}`,
            boxShadow: theme.customShadows.z8,
          }}
        >
          <CardHeader
            title={insight.name}
            titleTypographyProps={{
              variant: 'subtitle2',
            }}
            subheader={
              <Stack direction="row" spacing={2}>
                <Chip
                  label={`${t('text.tables.category')}: ${insight.category}`}
                  sx={{
                    height: 25,
                  }}
                  size="medium"
                  variant="soft"
                  color="secondary"
                  icon={<Category fontSize="small" sx={{ fontSize: '14px' }} />}
                />

                {insight?.topics?.length > 0 && (
                  <Chip
                    label={`${t('text.labels.topics')}: ${renderTopics(insight?.topics)}`}
                    sx={{
                      height: 25,
                    }}
                    size="medium"
                    variant="soft"
                    color="info"
                    icon={<Discount fontSize="small" sx={{ fontSize: '14px' }} />}
                  />
                )}
              </Stack>
            }
          />
          <CardContent>
            <Typography variant="body2">{insight?.reason || ''}</Typography>
            {insight?.extracts && (
              <Box
                sx={{
                  mt: 2,
                  backgroundColor: theme.palette.background.neutral,
                  borderRadius: 1,
                  px: 2,
                  py: 1,
                  border: `1px dashed ${theme.palette.divider}`,
                  width: 'auto',
                }}
              >
                <Typography variant="body2" fontStyle="italic">
                  {parseExtract(insight?.extracts || '')}
                </Typography>
              </Box>
            )}
          </CardContent>
        </Box>
      ))}
    </Stack>
  );
};
